import React from 'react';
import { useParams } from 'react-router-dom';

import PropTypes from 'prop-types';

import BookingContext from './BookingContext';

import useBookingHistoryDetails from 'queries/Booking/useBookingHistoryDetails';

const BookingProvider = ({ children }) => {

	const { bookingId } = useParams();

	const booking = useBookingHistoryDetails(bookingId);

	return (
		<BookingContext.Provider
			value={{
				...booking,
				booking: booking.data?.data
			}}
		>
			{children}
		</BookingContext.Provider>
	);
};

BookingProvider.propTypes = {
	children: PropTypes.node
};

export default BookingProvider;
